import { FC } from "react";

export const ArrowDownIcon: FC<{ className?: string }> = ({ className }) => (
    <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.6 7.45825L11.1667 12.8916C10.525 13.5333 9.47503 13.5333 8.83337 12.8916L3.40003 7.45825" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);